var Dropdown               = require("app/ui/Dropdown"),
    DropdownCaptureSupport = require("app/ui/DropdownCaptureSupport"),
    IconButton             = require("app/ui/IconButton"),
    PageThumbnailCarousel  = require("./PageThumbnailCarousel"),
    TapCommandSupport      = require("app/ui/TapCommandSupport"),
    ZoomDropdown           = require("./ZoomDropdown"),
    frameThrottle          = require("enyo-perf/utils").frameThrottle,
    icons                  = require("app/theme/icons"),
    kind                   = require("enyo/kind");

require("./Toolbar.less");
require("app/theme/IconButton--reader-toolbar.less");
require("app/theme/styles/popups/Popup--plain.less");

module.exports = kind(/** @lends  app.MediaPlayer.Tech.ImageReader.Toolbar.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.ImageReader.Toolbar",

    /**
     * @private
     */
    classes: "app-media-player-image-reader-toolbar",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @private
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:            "pageThumbnailDropdown",
        kind:            Dropdown,
        classes:         "app-media-player-image-reader-toolbar__page-thumbnail-dropdown",
        mixins:          [DropdownCaptureSupport],
        activatorKind:   null,
        dropdownOptions: {
            theme:           "plain",
            showCloseButton: false
        },
        tapContainerPath: ".owner",
        components:       [{
            name:    "pageThumbnailCarousel",
            kind:    PageThumbnailCarousel,
            classes: "app-media-player-image-reader-toolbar__page-thumbnail-carousel"
        }]
    }, {
        name:       "zoomingButtons",
        classes:    "app-media-player-image-reader-toolbar__zooming-buttons",
        components: [{
            name:    "zoomDropdown",
            kind:    ZoomDropdown,
            classes: "app-media-player-image-reader-toolbar__zoom-dropdown"
        }, {
            name:       "zoomOutButton",
            kind:       IconButton,
            classes:    "app-media-player-image-reader-toolbar__zoom-out-button",
            mixins:     [TapCommandSupport],
            icon:       icons["app.MediaPlayer.ImageReader.Toolbar.zoomOutButton"],
            theme:      "reader-toolbar",
            tapCommand: "onRequestZoomOut"
        }, {
            name:       "zoomInButton",
            kind:       IconButton,
            classes:    "app-media-player-image-reader-toolbar__zoom-in-button",
            mixins:     [TapCommandSupport],
            icon:       icons["app.MediaPlayer.ImageReader.Toolbar.zoomInButton"],
            theme:      "reader-toolbar",
            tapCommand: "onRequestZoomIn"
        }]
    }, {
        name:       "pagingButtons",
        classes:    "app-media-player-image-reader-toolbar__paging-buttons",
        components: [{
            name:       "firstPageButton",
            kind:       IconButton,
            classes:    "app-media-player-image-reader-toolbar__first-page-button",
            mixins:     [TapCommandSupport],
            icon:       icons["app.MediaPlayer.ImageReader.Toolbar.firstPageButton"],
            theme:      "reader-toolbar",
            tapCommand: "onRequestFirstPage"
        }, {
            name:       "previousPageButton",
            kind:       IconButton,
            classes:    "app-media-player-image-reader-toolbar__previous-page-button",
            mixins:     [TapCommandSupport],
            icon:       icons["app.MediaPlayer.ImageReader.Toolbar.previousPageButton"],
            theme:      "reader-toolbar",
            tapCommand: "onRequestPreviousPage"
        }, {
            name:    "browseButton",
            kind:    IconButton,
            classes: "app-media-player-image-reader-toolbar__browse-button",
            mixins:  [TapCommandSupport],
            icon:    icons["app.MediaPlayer.ImageReader.Toolbar.browseButton"],
            theme:   "reader-toolbar",
            ontap:   "toggleThumbnails"
        }, {
            name:       "nextPageButton",
            kind:       IconButton,
            classes:    "app-media-player-image-reader-toolbar__next-page-button",
            mixins:     [TapCommandSupport],
            icon:       icons["app.MediaPlayer.ImageReader.Toolbar.nextPageButton"],
            theme:      "reader-toolbar",
            tapCommand: "onRequestNextPage"
        }, {
            name:       "lastPageButton",
            kind:       IconButton,
            classes:    "app-media-player-image-reader-toolbar__last-page-button",
            mixins:     [TapCommandSupport],
            icon:       icons["app.MediaPlayer.ImageReader.Toolbar.lastPageButton"],
            theme:      "reader-toolbar",
            tapCommand: "onRequestLastPage"
        }]
    }, {
        name:       "fullscreenButtons",
        classes:    "app-media-player-image-reader-toolbar__fullscreen-buttons",
        components: [{
            name:       "fullscreenButton",
            kind:       IconButton,
            classes:    "app-media-player-image-reader-toolbar__fullscreen-button",
            mixins:     [TapCommandSupport],
            icon:       icons["app.MediaPlayer.ImageReader.Toolbar.fullscreenButton"],
            theme:      "reader-toolbar",
            tapCommand: "onRequestFullscreen"
        }, {
            name:       "exitFullscreenButton",
            kind:       IconButton,
            classes:    "app-media-player-image-reader-toolbar__exit-fullscreen-button",
            mixins:     [TapCommandSupport],
            icon:       icons["app.MediaPlayer.ImageReader.Toolbar.exitFullscreenButton"],
            theme:      "reader-toolbar",
            tapCommand: "onRequestExitFullscreen"
        }]
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".canvasView",
        to:   ".$.pageThumbnailCarousel.canvasView"
    }, {
        from: ".activeIndex",
        to:   ".$.pageThumbnailCarousel.activeIndex"
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
            this.fullscreenChanged();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            state       = this.state || {};

        // Button captions etc.
        this.$.zoomOutButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageReader.ZoomOutButton.tooltip"));
        this.$.zoomInButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageReader.ZoomInButton.tooltip"));
        this.$.firstPageButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageReader.FirstPageButton.tooltip"));
        this.$.previousPageButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageReader.PreviousPageButton.tooltip"));
        this.$.browseButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageReader.BrowseButton.tooltip"));
        this.$.nextPageButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageReader.NextPageButton.tooltip"));
        this.$.lastPageButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageReader.LastPageButton.tooltip"));
        this.$.fullscreenButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageReader.FullscreenButton.tooltip"));
        this.$.exitFullscreenButton.set("tooltip", i18nService.getString("app.MediaPlayer.ImageReader.ExitFullscreenButton.tooltip"));

        this.$.pageThumbnailCarousel.set("state", state);
    },

    /**
     * @private
     */
    fullscreenChanged: function() {
        var fullscreen = this.get("fullscreen");

        this.$.fullscreenButton.set("showing", !fullscreen);
        this.$.exitFullscreenButton.set("showing", fullscreen);
    },

    /**
     * @private
     */
    toggleThumbnails: function() {
        this.$.pageThumbnailDropdown.toggleDropdown();
    },

    /**
     * We use css flags as breakpoints because the reader might be minified, in
     * which case it's size is influenced by screen size.
     *
     * @private
     */
    reflow: kind.inherit(function(sup) {
        return function() {
            var toolbarWidth;

            sup.apply(this, arguments);
            toolbarWidth = this.getBounds().width;

            this.setAttribute("data-zoom-ui", toolbarWidth >= 520 ? "buttons" : "dropdown");
        };
    })

});
